import { createRef, Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

class _ExtraMenuContent extends Component {
  constructor(props) {
    super(props);
    this.ref = createRef();
  }

  componentDidMount() {
    const bounds = this.ref.current.getBoundingClientRect();
    const maxHeight = this.props.uiStore.isMobile
      ? this.checkHeight(bounds)
      : 'none';

    this.props.uiStore.setMaxHeightExtraMenu(maxHeight);
    this.props.uiStore.checkWidth(bounds.width);
  }

  checkHeight = (bounds) => {
    const difference = document.body.clientHeight - (bounds.top + this.ref.current.scrollHeight) - 5;

    return difference < 0 ? this.ref.current.scrollHeight - Math.abs(difference) : 'none';
  };

  render() {
    const { uiStore } = this.props;

    return (
      <>
        <div
          className={`pes-icon-dots__container ${uiStore.isFullWidth ? 'allow-wrap' : ''}`}
          style={uiStore.getExtraMenuStyles}
          ref={this.ref}
        >
          {this.props.children}
        </div>
        <div className="pes-icon-dots__overlay" onClick={this.props.handleOverlayCLick} />
      </>
    );
  }
}

_ExtraMenuContent.propTypes = {
  uiStore: propTypes.shape({
    extraMenuWidth: propTypes.oneOfType([
      propTypes.string,
      propTypes.number
    ]),
    extraMenuHeight: propTypes.oneOfType([
      propTypes.string,
      propTypes.number
    ]),
    isMobile: propTypes.bool,
    setMaxHeightExtraMenu: propTypes.func,
    getExtraMenuStyles: propTypes.shape({
      maxWidth: propTypes.oneOfType([
        propTypes.string,
        propTypes.number
      ]),
      width: propTypes.oneOfType([
        propTypes.string,
        propTypes.number
      ]),
      maxHeight: propTypes.oneOfType([
        propTypes.string,
        propTypes.number
      ])
    }),
    checkWidth: propTypes.func
  }).isRequired,

  handleOverlayCLick: propTypes.func.isRequired,
  children: propTypes.element.isRequired,
  isFullWidth: propTypes.bool
};

export const ExtraMenuContent = inject((allStores) => ({
  uiStore: allStores.uiStore
}))(observer(_ExtraMenuContent));
